export const ParseBandMW = value =>
  value !== undefined ? Number(value) : null;
